import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiErrorDetail, setToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = not auth, object = auth
  const [checked, setChecked] = useState(false);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    // Bearer-Token als Cookie-Fallback (iOS Safari/Privat) sichern
    if (data.access_token) setToken(data.access_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setToken("");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checked, login, logout, check, formatApiErrorDetail }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
